export enum ContainerHorizontalPadding {
  NONE = 'none',
  DEFAULT = 'default',
}
